import { Account, AccountEdit } from '../models/account';
import { ChartOrderBy, ChartStatus } from '../models/chart';
import { ClerkListResponse } from '../models/clerks';
import { backend } from '../utils/axios';

const ROUTE = "/clerks";

interface ClerksServiceEndpoints {
	getClerks: (
		showAdmin: boolean,
		showDisabled: boolean,
		chartStatus: ChartStatus,
		notPrinted?: boolean,
		printRequested?: boolean,
		query?: string,
		sortdesc?: ChartOrderBy,
	) => Promise<ClerkListResponse[]>;
	deleteClerk: (clerkId: string) => Promise<ClerkListResponse>;
	makeClerkAdmin: (clerkId: string) => Promise<ClerkListResponse>;
	removeClerkFromAdminRole: (clerkId: string) => Promise<ClerkListResponse>;
	resetPassword: (clerkId: string) => Promise<ClerkListResponse>;
	updateClerk: (data: AccountEdit) => Promise<Account>;
}

export const ClerksService: ClerksServiceEndpoints = {
	async getClerks(showAdmin, showDeleted, chartStatus, notPrinted, printRequested, query, sortdesc) {
		const params = new URLSearchParams();
		if (query) params.append("query", query);
		if (sortdesc) params.append("sortdesc", sortdesc);
		if (typeof showAdmin === "boolean") params.append("displayadmin", String(showAdmin));
		if (typeof showDeleted === "boolean") params.append("displaydisabled", String(showDeleted));
		if (typeof notPrinted === "boolean") params.append("notprinted", String(notPrinted));
		if (typeof printRequested) params.append("printrequested", String(printRequested));

		const { data } = await backend.get<ClerkListResponse[]>(
			`${ROUTE}/admin/${chartStatus}`,
			{ params }
		);

		return data;
	},
	deleteClerk: (clerkId) =>
		backend
			.delete<ClerkListResponse>(`${ROUTE}/admin/${clerkId}`)
			.then(({ data }) => data)
			.catch(),
	makeClerkAdmin: (clerkId) =>
		backend
			.put<ClerkListResponse>(`${ROUTE}/admin/make-admin/${clerkId}`)
			.then(({ data }) => data)
			.catch(),
	removeClerkFromAdminRole: (clerkId) =>
		backend
			.put<ClerkListResponse>(`${ROUTE}/admin/remove-admin/${clerkId}`)
			.then(({ data }) => data)
			.catch(),
	resetPassword: (clerkId) =>
		backend
			.post<ClerkListResponse>(`${ROUTE}/admin/reset-password/${clerkId}`)
			.then(({ data }) => data)
			.catch(),
	updateClerk: (data) =>
		backend
			.put<Account>(`${ROUTE}/admin`, data)
			.then(({ data }) => data)
			.catch(),
};
